import React from 'react';
import Form from 'js/components/common/Form';
import { Button } from 'js/components/common/Button';
import { Input } from 'js/components/common/Fields/Input';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import style from './index.scss';

import { password, passwordVerify } from 'js/hooks/user/validationConfig';

const validationConfig = {
    oldPassword: password,
    newPassword: password,
    passwordVerify: passwordVerify()
};

export default ({ onSubmit, t }) => (
    <Form
        onSubmit={onSubmit}
        validationConfig={validationConfig}
        render={({ submitting, pristine, submitError, handleSubmit }) => (
            <form
                className={style.form}
                onSubmit={event => event.preventDefault()}
            >
                {submitError && <ErrorMessage error={submitError} animate={true}/>}

                <Input
                    type="password"
                    name="oldPassword"
                    label={t('title.oldPassword')}
                    id="changePassword-oldPassword"
                    placeholder={t('title.oldPassword')}
                    aria-label={t(['title.oldPassword', 'playtech.mobile.system.input.aria-label'])}
                />

                <Input
                    type="password"
                    name="newPassword"
                    label={t('title.newPassword')}
                    id="changePassword-newPassword"
                    placeholder={t('title.newPassword')}
                    aria-label={t(['title.newPassword', 'playtech.mobile.system.input.aria-label'])}
                />

                <Input
                    type="password"
                    name="passwordVerify"
                    id="changePassword-verifyPassword"
                    label={t('title.newPasswordConfirm')}
                    placeholder={t('title.newPasswordConfirm')}
                    aria-label={t(['title.newPasswordConfirm', 'playtech.mobile.system.input.aria-label'])}
                />

                <div className={style.formActions}>
                    <Button
                        type="button"
                        onClick={handleSubmit}
                        className={style.submit}
                        disabled={submitting || pristine}
                    >
                        {t('button.change')}
                    </Button>
                </div>
            </form>
        )}
    />
);
